import app from '../../scripts/app';
import template from './phone-verify-form.jade';
import validation from './../../scripts/services/validation';

import {
  trackPhoneVerifyCodeSent,
  trackPhoneVerifyConfirm,
  trackPhoneVerifySuccess,
  trackPhoneVerifyError,
} from './tracking';

app.directive('cianAfPhoneVerifyForm', ['$rootScope', 'apiService', 'userService', 'remoteValidationService', ($rootScope, apiService, userService, remoteValidationService) => {
  return {
    template,
    scope: {},
    bindToController: {
      verifyPhoneHandler: '&?',
      phoneNumberToVerify: '=?',
    },
    require: ['^^form', 'cianAfPhoneVerifyForm'],
    link(scope, element, attrs, [form, ctrl]) {
      const codeSendFormCtrl = angular.element(element.find('ng-form')[0]).controller('form');
      form.$removeControl(codeSendFormCtrl); // удаляемся из формы, что бы была доступна кнопка "Зарегистрироваться"

      ctrl.validationPhoneNumber = validation(ctrl.phoneForm, 'phone.Number', {
        required: 'Обязательное поле',
      });

      ctrl.validationCodeSend = validation(ctrl.phoneForm, 'codeSent', {
        required: 'Отправьте код подтверждения',
      });

      if (!ctrl.phoneForm.remoteValidator) {
        ctrl.phoneForm.remoteValidator = remoteValidationService.getInstance(ctrl.phoneForm);
      }
    },
    controller: [
      'addFormService', 'deviceService',
      function (addFormService, deviceService)
    {
      this.isMobile = deviceService.isMobile;
      this.codeSent = null;
      this.codeVerified = null;
      this.codeSendingDisabled = false;
      this.phoneVerified = false;
      this.validationCode = '';
      this.validationCodeRequestInProgress = false;
      this.verifyPhoneRequestInProgress = false;

      this.phoneVerified = userService.verifiedPhoneNumberInCurrentSession;
      if (this.phoneVerified) {
        userService.getUser().then(user => {
          this.phoneNumber = user.phoneNumbers[0];
        });
      }

      this.validation = validation(() => this.codeForm, 'phone.ValidationCode', {
        required: 'Введите код подтверждения',
      });

      this.validationCodeVerified = validation(() => this.codeForm, 'codeVerified', {
        required: 'Подтвердите номер телефона',
      });

      this.sendCode = () => {
        this.validationCodeRequestInProgress = true;
        this.phoneNumberToVerify = {
          validationCode: '',
          ...this.phoneNumber,
        };

        trackPhoneVerifyCodeSent();

        apiService.sendValidationCode(this.phoneNumber).then(() => {
          this.codeSent = true;
          this.codeSendingDisabled = true;
        }, response => {
          if (response.data && response.data.data) {
            const dataErrors = {
              errors: {},
            };
            if (response.data.data._schema && response.data.data._schema[0]) { // eslint-disable-line
              dataErrors.errors['phone.Number'] = response.data.data._schema[0]; // eslint-disable-line
            }
            if (response.data.data.number && response.data.data.number[0]) { // eslint-disable-line
              dataErrors.errors['phone.Number'] = response.data.data.number[0]; // eslint-disable-line
            }
            this.phoneForm.remoteValidator.setValidators(dataErrors);
          }
        }).finally(() => this.validationCodeRequestInProgress = false);
      };

      this.setCodeVerified = () => {
        this.codeVerified = true;
      };

      this.verifyPhone = () => {
        if (!this.codeForm.remoteValidator) {
          this.codeForm.remoteValidator = remoteValidationService.getInstance(this.codeForm);
        }
        if (this.codeForm.$valid) {
          // verifyPhoneHandler should return promise
          if (this.verifyPhoneHandler) {
            this.verifyPhoneRequestInProgress = true;

            trackPhoneVerifyConfirm();

            this.verifyPhoneHandler({
              $phoneNumberToVerify: this.phoneNumberToVerify,
            }).then(() => {
              trackPhoneVerifySuccess();

              this.phoneVerified = true;
              userService.addPhone({
                countryCode: this.phoneNumberToVerify.countryCode,
                number: this.phoneNumberToVerify.number,
              });

              addFormService.form.$setValidity('phoneNumber', true);
            }, response => {
              trackPhoneVerifyError();

              if (response.status === 400) {
                if (response.data.data && response.data.data.errors) {
                  /*
                  преобразование ответа сервера - изменение названия поля на нужное нам phone.ValidationCode
                  эта форма используется так же и при регистрации и код ошибки от сервера в регистрации будет phone.ValidationCode
                  а при подтверждении код ошибки validationCode
                  TODO возможно переделать
                  */
                  const dataResponse = { ...response.data.data };
                  dataResponse.errors = {};
                  for (const errorCode in response.data.data.errors) {
                    let dataErrorKey = errorCode;
                    const dataError = response.data.data.errors[errorCode];
                    if (errorCode === 'validationCode') {
                      dataErrorKey = 'phone.ValidationCode';
                    }
                    else if (errorCode === 'number') {
                      dataErrorKey = 'phone.Number';
                    }
                    dataResponse.errors[dataErrorKey] = dataError;
                  }
                  this.codeForm.remoteValidator.setValidators(dataResponse);
                  this.phoneForm.remoteValidator.setValidators(dataResponse);
                }
              }
            }).finally(() => {
              this.verifyPhoneRequestInProgress = false;
              this.codeVerified = null;
              this.codeVerified.$setPristine();
            });
          }
        }
      };

      $rootScope.$on('registration.invalidCode', (event, data) => {
        if (this.codeForm && this.codeForm.codeVerified) {
          if (!this.codeForm.remoteValidator) {
            this.codeForm.remoteValidator = remoteValidationService.getInstance(this.codeForm);
          }
          this.codeForm.remoteValidator.setValidators({ errors: { 'phone.ValidationCode': data } });
        } else {
          if (this.phoneForm) {
            this.phoneForm.remoteValidator.setValidators({ errors: { codeSent: [{ message: 'Отправьте код подтверждения', code: 'message' }] } });
          }
        }
      });

      $rootScope.$on('registration.invalidNumber', (event, data) => {
        if (this.phoneForm) {
          if (this.phoneNumberToVerify.number) {
            this.phoneForm.remoteValidator.setValidators({ errors: { 'phone.Number': data } });
          } else {
            this.phoneForm.remoteValidator.setValidators({ errors: { codeSent: [{ message: 'Отправьте код подтверждения', code: 'message' }] } });
          }
        }
      });

      $rootScope.$on('publish.invalidNumber', (event, data) => {
        if (this.phoneForm) {
          this.phoneForm.remoteValidator.setValidators({ errors: { codeSent: [{ message: 'Подтвердите телефон', code: 'message' }] } });
        }
      });

      $rootScope.$on('registration.validatePhoneVerifyForm', () => {
        if (this.codeForm && this.codeForm.codeVerified) {
          this.codeForm.codeVerified.$setValidity('required', true);
        }
        if (this.phoneForm) {
          this.phoneForm.$setSubmitted();
        }

      });

      $rootScope.$on('addform.submit', () => {
        if (this.phoneForm) {
          this.phoneForm.$setSubmitted();

          if (this.phoneForm.$invalid) {
            addFormService.form.$setValidity('phoneNumber', false);
          }
        }
      });

      this.onCountDownFinished = () => {
        this.codeSendingDisabled = false;
      };
    }],
    controllerAs: 'phoneVerifyFormCtrl',
    replace: true,
  };
}]);
